import { TextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { twMerge } from "tailwind-merge"

interface Option {
    id: string
    value: number
    label: string
}

interface SelectProps {
    selectValue: any
    textFieldProps: MuiTextFieldProps
    options: Option[]
    className?: string
    inputProps: any
    onChange?: (value: any) => void;
    placeholder?: string
    disabled?: boolean
}

export function Element({ selectValue, textFieldProps, options, onChange = () => {}, ...rest }: SelectProps) {
    return (
        <TextField className={twMerge("", rest.className)}
            size='small'
            select
            disabled= {rest.disabled}
            value={selectValue}
            placeholder={rest.placeholder}
            onChange={(e) => onChange(e.target.value)} 
            sx={{
                '& .MuiOutlinedInput-root': {
                    // borderRadius: '12px',
                    // height: '40px'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    // borderRadius: '12px',
                    // borderColor: '#8A8A8A',
                    // height: '40px'
                },
            }}
            InputProps={rest.inputProps}
            inputProps={rest.inputProps}
            {...textFieldProps}
        >
            {
                options.map((option) => (
                    <MenuItem key={option.id} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))
            }
        </TextField >
    )
}
